import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import { window } from '../../helpers/BrowserHelpers';

var ArrowContainer = function ArrowContainer(_ref) {
  var position = _ref.position,
      targetRect = _ref.targetRect,
      popoverRect = _ref.popoverRect,
      _ref$arrowSize = _ref.arrowSize,
      arrowSize = _ref$arrowSize === void 0 ? 10 : _ref$arrowSize,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$arrowColor = _ref.arrowColor,
      arrowColor = _ref$arrowColor === void 0 ? 'black' : _ref$arrowColor;
  return React.createElement("div", {
    style: _objectSpread({
      position: 'absolute'
    }, function () {
      var arrowWidth = arrowSize * 2;
      var top = targetRect.top - popoverRect.top - window.pageYOffset + targetRect.height / 2 - arrowWidth / 2;
      var left = targetRect.left - popoverRect.left - window.pageXOffset + targetRect.width / 2 - arrowWidth / 2;
      left = left < 0 ? 0 : left;
      left = left + arrowWidth > popoverRect.width ? popoverRect.width - arrowWidth : left;
      top = top < 0 ? 0 : top;
      top = top + arrowWidth > popoverRect.height ? popoverRect.height - arrowWidth : top;

      switch (position) {
        case 'right':
          return {
            borderTop: "".concat(arrowSize, "px solid transparent"),
            borderBottom: "".concat(arrowSize, "px solid transparent"),
            borderRight: "".concat(arrowSize, "px solid ").concat(arrowColor),
            left: -arrowSize,
            top: top
          };

        case 'left':
          return {
            borderTop: "".concat(arrowSize, "px solid transparent"),
            borderBottom: "".concat(arrowSize, "px solid transparent"),
            borderLeft: "".concat(arrowSize, "px solid ").concat(arrowColor),
            right: -arrowSize,
            top: top
          };

        case 'bottom':
          return {
            borderLeft: "".concat(arrowSize, "px solid transparent"),
            borderRight: "".concat(arrowSize, "px solid transparent"),
            borderBottom: "".concat(arrowSize, "px solid ").concat(arrowColor),
            top: -arrowSize,
            left: left
          };

        case 'top':
        default:
          return {
            borderLeft: "".concat(arrowSize, "px solid transparent"),
            borderRight: "".concat(arrowSize, "px solid transparent"),
            borderTop: "".concat(arrowSize, "px solid ").concat(arrowColor),
            bottom: -arrowSize,
            left: left
          };
      }
    }(), {}, style)
  });
};

export default ArrowContainer;